import { useEffect, useRef, useState } from "react";
import style from "./Carousel.module.css";
import { useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";

function PopupCarousel(props) {
  const ref = useRef(null);
  const activeListingId = useSelector(
    ListingreducerSelectors.activeListingIdSelactor
  );
  
  const mapListing = useSelector(ListingreducerSelectors.mapListingSelactor);

  useEffect(() => {
    if (mapListing.listing) {
      if (ref.current) {
        ref.current.scrollLeft = 0;
      }
    }
  }, [mapListing.listing]);

  function logit() {
    const slider = ref.current;
    props.setCurrentIndex(Math.floor(slider.scrollLeft / props.width));
  }

  useEffect(() => {
    const slider = ref.current;

    function watchScroll() {
      if (slider) {
        slider.addEventListener("scroll", logit);
      }
    }
    watchScroll();
    return () => {
      if (slider) {
        slider.removeEventListener("scroll", logit);
      }
    };
  }, []);

  return (
    <div
      className={style.container}
      style={props.NewStyle ? props.NewStyle : {}}
    >
      <div className={style.Carousel} ref={ref}>
        {props.children}
      </div>
    </div>
  );
}

export default PopupCarousel;
